<template>
<div id="barcode">
    <div>
        <div class="barcode-close-area">
            <div class="barcode-btn-close"></div>
        </div>
        <div class="barcode-wrap">
            <div class="barcode-info-area">
                <div class="barcode-info-title">
                    <div>
                        <p>
                            <span><b>{{user_name}}</b>님</span>
                            <br>
                            <b>{{store_name}}</b>
                            <span>입니다.</span>
                        </p>
                    </div>
                </div>
                <div class="barcode-info-body">
                    <div class="barcode-info-body-area">
                        <div class="barcode-info-body-tab">
                            <div @click="seat_select(0)" class="barcode-seat-kind active">
                                <span>일반석</span>
                            </div>
                            <div @click="seat_select(1)" class="barcode-seat-kind">
                                <span>그룹룸</span>
                            </div>
                        </div>
                        <div class="barcode-info-body-using">
                            <div v-if="(seat_using_chk && seat_kind == 0) || (groom_using_chk && seat_kind == 1)">
                                <div class="seatName" v-if="seat_kind == 0">{{seat_name}} 번</div>
                                <div class="goodName" v-if="seat_kind == 0">[{{seat_type_name}}] {{goods_seat_name}}</div>
                                <div class="useTime" v-if="seat_kind == 0">
                                    <font-awesome-icon :icon="['far','clock']" /><span>{{seat_start_time}} ~ {{total_sum_end_date}}</span>
                                </div>

                                <div class="seatName" v-if="seat_kind == 1">{{groom_name}}</div>
                                <div class="goodName" v-if="seat_kind == 1">[{{groom_name}}] {{goods_group_name}}</div>
                                <div class="useTime" v-if="seat_kind == 1">
                                    <font-awesome-icon :icon="['far','clock']" /><span>{{groom_start_time}} ~ {{groom_end_time}}</span>
                                </div>
                            </div>
                            <div v-if="(!seat_using_chk && seat_kind == 0) || (!groom_using_chk && seat_kind == 1)">
                                <div class="disable-seat">이용중이 아닙니다.</div>
                            </div>
                        </div>
                        <div class="barcode-info-body-menu" v-if="(seat_using_chk && seat_kind == 0) || (groom_using_chk && seat_kind == 1)">
                            <div class="barcode-info-body-seat" v-if="seat_kind == 0">
                                <div class="seatMove" @click="seat_move"><img src="../../assets/image/seat_move.png"><span>자리이동</span></div>
                                <div class="seatEx" @click="seat_ex" v-if="!continue_seat_purchase_history_flag"><img src="../../assets/image/seat_ex.png"><span>이용연장</span></div>
                                <div class="seatEx" @click="seat_ex" v-else><img src="../../assets/image/seat_ex.png"><span>연장상품 변경</span></div>
                                <div class="seatEnd" @click="seat_use_end"><img src="../../assets/image/seat_end.png"><span>이용종료</span></div>
                            </div>
                        </div>
                        <div class="barcode-info-body-barcode" v-if="(seat_using_chk && seat_kind == 0) || (groom_using_chk && seat_kind == 1)" @click="barcode_expantion">
                            <barcode-image v-if="seat_kind == 0" :value="barcodeValue[0].barcode_code" format="CODE128" width="2" font-size="0" ></barcode-image>
                            <barcode-image v-if="seat_kind == 1" :value="barcodeValue[groom_barcode_index].barcode_code" format="CODE128" width="2" font-size="0"></barcode-image>                            
                            <div><p>출입 시 바코드를 리더기에 스캔하세요.</p><p>리더기 불빛이 닿지 않는 경우 바코드를 누르세요.</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style>

</style>
<script>
// 사용자 정의 모듈.
import * as config from '../../javascript/config';
import VueBarcode from 'vue-barcode';
import moment from 'vue-moment';
import { EventBus } from '../../main.js';
export default {
    name: 'barcode',
    data() {
        return {
            user_id: "",
            store_id: "",
            user_name: "",
            store_name: "",
            barcodeInfo: "010552810471234",
            seat_using_chk: false,
            // 개인석
            seat_id: "",
            seat_use_id: "",
            main_seat_type_code: "",
            seat_name: "",
            seat_kind: 0,
            seat_start_time: "",
            seat_end_time: "",
            seat_type_name: "",
            seat_type_code: "",
            seat_status_code: "",
            goods_seat_name: "",
            goods_end_datetime: "",
            continue_use_hours_plan: "",
            // 그룹룸
            groom_using_chk: false,
            groom_name: "",         // 좌석명
            goods_group_name: "",   // 상품명
            groom_start_time: "",
            groom_end_time: "",
            // 바코드
            barcodeValue: "",
            goods_groom_name: "",
            groom_reservation_id:"",
            groom_barcode_index:1
        }
    },
    components: {
        'barcode-image': VueBarcode
    },
    methods: {
        seat_select(kind){
            this.main_data_setting();
            this.seat_kind = kind;
        },
        seat_data_load() {
            const type_seat = config.REQ_SEAT_USE_GET_LIST; // 현재 이용중인 상품정보 노출
            this.$store.dispatch(type_seat.action_name, {
                type: type_seat,
                data: {}
            }).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].day_count == null) {
                        this.time_goods_flag = 1
                    } else {
                        this.time_goods_flag = 0
                    }
                    if (response.data[0].continue_seat_purchase_history_id != null) {
                        this.continue_seat_purchase_history_flag = true;
                    } else {
                        this.continue_seat_purchase_history_flag = false;
                    }
                    this.seat_using_chk = true;
                    this.seat_id = response.data[0].seat_id;
                    this.seat_use_id = response.data[0].seat_use_id;
                    this.seat_name = response.data[0].seat_name;
                    this.seat_start_time = response.data[0].use_start_datetime;
                    this.seat_end_time = response.data[0].use_end_datetime;
                    this.seat_type_name = response.data[0].seat_type_name;
                    this.continue_use_hours_plan = response.data[0].continue_use_hours_plan;
                    this.goods_end_datetime = response.data[0].goods_end_datetime;
                    this.main_seat_type_code = response.data[0].main_seat_type_code;
                    //this.seat_type_code = response.data[0].seat_type_code;
                    //this.seat_status_code = response.data[0].seat_status_code;
					
                    let goods_name = this.$store.getters['getGoods_name'];
                    this.goods_seat_name = goods_name.using_seat_goods_name;
                    this.goods_groom_name = goods_name.using_groom_goods_name;

                    this.total_sum_end_date = this.$moment(this.seat_end_time).add(this.continue_use_hours_plan).format("YYYY-MM-DD HH:mm");
					 
                    this.$store.commit('set_my_seat_data', {
                        seat_id: this.seat_id,
                        seat_name: this.seat_name,
                        seat_use_id: this.seat_use_id,
                        use_start_datetime: this.seat_start_time,
                        use_end_datetime: this.seat_end_time,
                        seat_type_code: response.data[0].seat_type_code,
                        // 연장사용시간계획 추가조회 2020.11.29 cjb
                        continue_use_hours_plan: this.continue_use_hours_plan,
                        goods_end_datetime: this.front_goods_end_datetime,
                        left_time: response.data[0].left_time,
                        use_total_time: response.data[0].use_total_time,
                        map_group_id: this.map_group_id,
                        main_seat_type_code: this.main_seat_type_code,
                        total_sum_end_date: this.total_sum_end_date,
                    }); 
                    this.$store.commit('set_select_seat', {
                        seat_id: response.data[0].seat_id,
                        seat_name: response.data[0].seat_name,
                        seat_type_code: response.data[0].seat_type_code,
                        seat_type_name: response.data[0].seat_type_name,
                        seat_status_code: response.data[0].seat_status_code,
                        main_seat_type_code: response.data[0].main_seat_type_code
                    });
                } else {
                    this.seat_using_chk = false;
                }
                /* this.$store.commit('setFor_pop_txt', this.seat_using_chk); */

            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        groom_data_load() {
            const groom_type = config.REQ_GROOM_USE_CHECK;
            this.$store.dispatch(groom_type.action_name, {
                type: groom_type,
                data: {}
            }).then(response => {
                if(response.data.length > 0){
                    for (let i = 0; i < response.data.length; i++) {
                        if (response.data[i].user_id == this.user_id) {
                            this.groom_using_chk = true;
                            this.groom_name = response.data[i].groom_name;
                            this.groom_start_time = response.data[i].use_start_datetime;
                            this.groom_end_time = response.data[i].use_end_datetime;
                            this.goods_group_name = response.data[i].goods_group_name;
                            this.groom_reservation_id = response.data[i].groom_reservation_id;
                     
                            if(parseInt(this.groom_reservation_id) > 0){
                                for(let j=0; j<this.barcodeValue.length;j++){                                        
                                    if(this.barcodeValue[j].groom_reservation_id == this.groom_reservation_id){
                                        this.groom_barcode_index = j;
                                    }
                                }
                            }else{
                                this.groom_barcode_index = 1;
                            }

                        }
                    }
                }else{
                    this.groom_using_chk = false;
                    this.groom_name = "";
                    this.groom_start_time = "";
                    this.groom_end_time = "";
                    this.goods_group_name = "";

                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        barcode_data_load() {
            const barcode_type = config.REQ_GET_BARCODE_INFO;
            const data_barcode = {
                store_id: this.store_id,
                user_id: this.user_id
            };
            this.$store.dispatch(barcode_type.action_name, {
                type: barcode_type,
                data: data_barcode
            }).then(response => {
                if (response.result) {
                    if (response.data.length != 0) {
                        for(let i=0;i<response.data.contents.length;i++){
                            if(response.data.contents[i].barcode_type_code == "BARCODE_SEAT"){
                                this.$store.commit('set_seat_barcode', response.data.contents[i].barcode_code );
                            }
                            if(response.data.contents[i].barcode_type_code == "BARCODE_GROOM"){
                                this.$store.commit('set_groom_barcode', response.data.contents[i].barcode_code );
                            }
                        }
                    }
                }
                this.barcodeValue = response.data.contents;
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        main_data_setting() {
            var user_info = this.$store.getters['getUser'];
            var store_info = this.$store.getters['getStoreInfo'];
            
            this.user_name = user_info.name;
            this.store_name = store_info.store_name;
            this.user_id = user_info.user_id;
            this.store_id = user_info.store_id;

            this.barcode_data_load();
            this.seat_data_load();
            this.groom_data_load();            
        },
        /* 
        floor_tab(item, index) {
            this.map_img = config.SYS_HOST + `/images/kiosk/${item.map_img}`;
            this.map_group_id = item.map_group_id;
            this.background_data = item;
            this.tab_index = index;
        },
        move_seat() {
            this.tab_data = this.$store.getters['get_map_group_list'];
            this.floor_tab(this.tab_data[0], 0);
            this.popup_code = 21;
            return;
        }, */
        seat_move() {
            EventBus.$emit('floor_tab');
            this.$store.commit('set_Last_URL', '/barcode');

            this.$store.commit('set_popup_type', {
                code: this.$store.getters['get_popup_code'].POPUP_SEAT_MOVE_MAP,
            }); 
        },
        seat_ex() {
            var store_pay_info = this.$store.getters['getStore_pay_info'];
            this.$store.commit('setFrom_front', 'barcode');
            this.$store.commit('set_Last_URL', '/barcode');
            if (store_pay_info) {
                if (this.continue_seat_purchase_history_flag) {                    
				    this.$store.commit('set_popup_type', {
					    code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST
				    });
                } else {
                    this.$store.commit('setExtention_flag', {
                        value: true
                    });
                    this.$router.push('/payment-seat') // 이동 위치를 입력
                }
            } else {
                this.$store.commit('set_popup_type', {
                    code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST,
                });
            }
        },        
        seat_use_end() {
            if (this.main_seat_type_code == "FIXED") {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_CHECK_OUT_TEXT,
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            } 
            let nowDate = this.$moment();
            let endDate = this.$moment(this.seat_end_time);
            let diffTime = {
                day : this.$moment.duration(endDate.diff(nowDate)).days() != 0?this.$moment.duration(endDate.diff(nowDate)).days() + "일 ":"",
                hour : this.$moment.duration(endDate.diff(nowDate)).hours() != 0?this.$moment.duration(endDate.diff(nowDate)).hours() + "시간 ":"",
                minute : this.$moment.duration(endDate.diff(nowDate)).minutes() != 0?this.$moment.duration(endDate.diff(nowDate)).minutes() + "분":"",
                totalMinute: this.$moment.duration(endDate.diff(nowDate)).asMinutes()
            }
            this.seat_left_time = diffTime.day + diffTime.hour + diffTime.minute;

            if (diffTime.totalMinute <= 5) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `상품 만료시간 5분전에는<br>종료 할 수 없으며,<br>5분 후 자동 종료 처리<br> 됩니다.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_USE_FINISH_S,
            };
            this.$store.commit('set_use_end_info', {
                seat_id: this.seat_id,
                seat_use_id: this.seat_use_id,
                seat_left_time: this.seat_left_time,
                seat_use_end_time: this.seat_end_time,
                seat_expire_time: this.goods_end_datetime
            })
            this.$store.commit('set_popup_type', alert_param);
            this.$store.commit('setFrom_front', 'barcode');
        },
        barcode_expantion() {
            this.$store.commit('set_popup_type', {
                code: this.$store.getters.get_popup_code.POPUP_BARCODE_EXPANTION,
                message: this.barcodeValue[this.seat_kind].barcode_code
            });
        }
    },
    mounted() {
        this.main_data_setting();
    },
    computed: {
        get_seat_kind() {
            return this.seat_kind;
        },
        get_popup_code(){
            return this.$store.getters.get_popup_type.code;
        }
    },
    watch: {
        get_seat_kind() {
            let seat_list = document.querySelectorAll('.barcode-seat-kind');
            seat_list.forEach(e => {
                e.classList.remove('active');
            })
            seat_list[this.seat_kind].classList.add('active');
        },
        get_popup_code() {
            if(this.$store.getters.get_popup_type.code == 0){
                this.main_data_setting();
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/page/barcode.vue